import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../../common/Mypage.scss';
import '../../../recruit/common/Recruit.scss';
import '../../../minister/pages/ministerInfo/MinisterInfo.scss';
import MainURL from '../../../../MainURL';
import Loading from '../../../../components/Loading';
import { useAtom } from 'jotai';
import { userDataAtom } from '../../../../AtomStore';
import MypageMenu from '../../common/MypageMenu';
import type { MinisterInfoDetail as MinisterInfoDetailData } from '../../../minister/pages/ministerInfo/ministerInfoTypes';
import {
  MinisterInfoDetailContent,
  PortfolioContent,
  SelfIntroductionContent,
} from '../../../minister/pages/ministerInfo/MinisterInfoDetail';

// 마이페이지 > 이력서 관리 '보기' — 본인 이력서·자기소개서·포트폴리오 열람
export default function ResumeView() {
  const navigate = useNavigate();
  const location = useLocation();
  const resumeId = new URLSearchParams(location.search).get('id') || '';
  const [userData] = useAtom(userDataAtom);

  const [resume, setResume] = useState<MinisterInfoDetailData | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!resumeId || !userData.userAccount) return;

    setLoading(true);
    axios.get(`${MainURL}/resume/getresume/${resumeId}`, {
      params: { userAccount: userData.userAccount }
    })
      .then(res => {
        if (res.data.success && res.data.resume) {
          const data = res.data.resume;
          setResume({
            ...data,
            id: String(data.id),
            updatedAt: data.updatedAt ? new Date(data.updatedAt).toLocaleDateString('ko-KR') : (data.saveDate || ''),
          });
        } else {
          setResume(null);
        }
      })
      .catch(err => {
        console.error('이력서 조회 실패:', err);
        setResume(null);
      })
      .finally(() => setLoading(false));
  }, [resumeId, userData.userAccount]);

  const goList = () => {
    navigate('/mypage/resumemanage');
    window.scrollTo(0, 0);
  };

  const goEdit = () => {
    navigate(`/mypage/resumeedit?id=${resumeId}`);
    window.scrollTo(0, 0);
  };

  const [copied, setCopied] = useState(false);

  const copyLink = async () => {
    const url = `${window.location.origin}/mypage/resumeview?id=${resumeId}`;
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      // clipboard API 미지원(구형 브라우저/웹뷰) 폴백
      const textarea = document.createElement('textarea');
      textarea.value = url;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
    }
    setCopied(true);
  };

  return (
    <div className="mypage">
      <div className="inner">
        <MypageMenu />
        <div className="subpage__main">
          {loading ? (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '50px' }}>
              <Loading />
            </div>
          ) : !resume ? (
            <div className="mypage-panel mypage-section-card">
              <div className="noPosts">
                <p>이력서를 찾을 수 없습니다.</p>
              </div>
            </div>
          ) : (
            <div className="mypage-panel mypage-section-card minister-info">
              <section style={{ marginBottom: '30px' }}>
                <div className="main_title_row">
                  <h3 className="main_title">{resume.title || `${resume.name} 님의 이력서`}</h3>
                  <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '8px', marginTop: '12px' }}>
                    <div className="list-btn" onClick={goEdit}>
                      <span>수정하기</span>
                    </div>
                    <div className="list-btn" onClick={copyLink}>
                      <span>{copied ? '복사됨' : '링크복사'}</span>
                    </div>
                    <div className="list-btn" onClick={goList}>
                      <span>목록으로</span>
                    </div>
                    <span style={{ marginLeft: 'auto', color: 'var(--ink-4)', fontSize: '16px' }}>수정일 {resume.updatedAt}</span>
                  </div>
                </div>
              </section>

              <div className="minister-info__block">
                <h2 className="minister-info__block-title">이력서</h2>
                <MinisterInfoDetailContent resume={resume} />
              </div>

              <div className="minister-info__block">
                <h2 className="minister-info__block-title">자기소개서</h2>
                <SelfIntroductionContent resume={resume} />
              </div>

              <div className="minister-info__block">
                <h2 className="minister-info__block-title">
                  사역 포트폴리오
                  {(resume.portfolioItems?.length ?? 0) > 0 && <span>{resume.portfolioItems?.length}</span>}
                </h2>
                <PortfolioContent resume={resume} />
              </div>
            </div>
          )}

          <div className="bottom-list-btn-wrap">
            <div className="bottom-list-btn-inner">
              <div className="list-btn list-btn--bottom" onClick={goList}>
                <span>목록으로</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
